const _ = window._
import {registerReducer} from 'js/studios/shared/redux/utils'


var defaultUpload = {
  'key': '',
  'uploading': false,
  'uploaderKey': '',
  'error': '',
  'file': null,
  'isImage': true,
  'data': {}
}

/**
 * General format for uploadsWidget
 *
 * {
 *   uploading
 * }
 */
function uploadsWidget(state, action){
  state = state || {
    'uploading': false,
    'error': '',
    'uploads': [],
    'uploadedIds': []
  }
  var newState = Object.assign({}, state)
  var uploads = newState.uploads.map(upload => Object.assign({}, defaultUpload, upload))
  var index, currentUpload
  switch(action.type){
    case "ADD_UPLOADS":
      for (let fileIndex in action.uploadedFiles){
        let uploadedFile = action.uploadedFiles[fileIndex]
        let key = uploadedFile.name + uploadedFile.size
        if (_.findIndex(uploads, value => value.key === key) === -1){
          uploads = _.filter(uploads, value => value.key !== key)

          let newUpload = {
            'key': key,
            'uploading': true,
            'uploaderKey': action.uploaderKey,
            'error': '',
            'file': uploadedFile,
            'isImage': ['image/jpeg', 'image/png'].indexOf(uploadedFile.type) > -1,
            'data': {}
          }
          uploads.push(Object.assign({}, defaultUpload, newUpload))
        }
      }
      newState.uploads = _.uniq(uploads, value => value.key)
      break

    case "ADD_SAVED_UPLOADS":
      for (let index in action.savedUploads){
        let savedUpload = action.savedUploads[index]
        let uploaderKey = action.uploaderKey || savedUpload.uploaderKey || undefined
        let key = uploaderKey + ":" + savedUpload.id
        if (_.findIndex(uploads, value => value.key === key) === -1){
          let newUpload = {
            'key': key,
            'id': savedUpload.id,
            'uploading': false,
            'uploaderKey': uploaderKey,
            'error': '',
            'file': null,
            'isImage': savedUpload.isImage,
            'data': savedUpload.data ? savedUpload.data : savedUpload
          }
          uploads.push(Object.assign({}, defaultUpload, newUpload))
        }
      }
      newState.uploads = _.uniq(uploads, value => value.key)
      break

    case "REMOVE_UPLOAD":
      newState.uploads = _.filter(uploads, value => value.key !== action.key)
      break

    case "SUCCESSFUL_ATTACHMENT":
      index = _.findIndex(uploads, value => value.key === action.key)
      currentUpload = uploads[index]
      if (currentUpload){
        currentUpload.data = action.data
        currentUpload.error = ''
        currentUpload.uploading = false
        uploads[index] = Object.assign({}, currentUpload, action.data)
        newState.uploads = uploads
      }
      break

    case "FAILED_ATTACHMENT":
      index = _.findIndex(uploads, value => value.key === action.key)
      currentUpload = uploads[index]
      if (currentUpload){
        currentUpload.data = {}
        currentUpload.error = action.error
        currentUpload.uploading = false
        newState.uploads = uploads
      }
      break
    case "CLEAR_UPLOADS":
      newState.uploads = uploads.filter(upload => upload.uploaderKey !== action.uploaderKey)
      break
    case "MOVE_UPLOAD": {
      const uploadIdx = uploads.findIndex(u => u.key === action.upload.key)
      uploads[uploadIdx] = uploads[uploadIdx + action.delta]
      uploads[uploadIdx + action.delta] = action.upload
      newState.uploads = uploads
      break
    }
    default:
      return state
  }

  // calculate global uploading & error state
  uploads = newState.uploads
  let uploading = false
  let errors = []
  for (const uploadIndex in uploads){
    if (uploads[uploadIndex].uploading) {
      uploading = true
    }
    if (uploads[uploadIndex].error) {
      errors.push(uploads[uploadIndex].file.name + ": " + uploads[uploadIndex].error)
    }
  }
  newState.error = errors.join("\n")
  newState.uploading = uploading
  newState.uploadedIds = uploads.filter(value => !value.error).map(upload => upload.data.id)
  return newState
}

registerReducer(uploadsWidget, 'uploadsWidget')
